import React from 'react'
import DocumentTitle from 'react-document-title'

import {withStyles, Grid, Typography, Card, CardContent, CardMedia} from 'material-ui'


const styles = theme => ({
    container: {
        zIndex: 1,
        position: 'relative',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        margin: "0 auto",
        background: "white",
    },
    content: {
        padding: 20,
        maxWidth: theme.layout.contentWidth,
        margin: "0 auto",
        marginBottom: 60,
        '& h1': theme.typography.headline,
        '& h2': theme.typography.subheading,
        '& p': theme.typography.body1,
    },
    grow: {
        flex: 1
    },
    titleMargins: {
        marginTop: "2em",
        marginBottom: "2em",
    },
    card: {
        maxWidth: 345,
    },
    media: {
        height: "13em",
    },
    cardContent: {
        // minHeight: "6.6em",
    }
})

export const Features1 = withStyles(styles)(
    ({classes}) => (
    <div className={classes.container}>
        <div className={classes.content}>
            <Grid container spacing={24}>
                <Grid item xs={1}/>
                <Grid item xs={10}>
                    <Typography component="h1" align="center" className={classes.titleMargins}><strong>Carefolio supports, guides, and empowers families as they assume caregiving roles for their loved ones.</strong></Typography>
                </Grid>
                <Grid item sm={3}>
                    <FeatureCard
                        title="Don't Miss a Thing"
                        text="Easily track doctor's appointments, medicine, images, notes, and calendar reminders."
                        color="lightgray"
                        image='/img/phone1-crop.png'/>
                </Grid>
                <Grid item sm={3}>
                    <FeatureCard
                        title="Smart Search"
                        text="Organize and search information so it is accessible when you need it."
                        color="lightgray"
                        image='/img/phone2-crop.png'/>
                </Grid>
                <Grid item sm={3}>
                    <FeatureCard
                        title="Capture Everything"
                        text="Conveniently collect important medical and legal information."
                        color="lightgray"
                        image='/img/phone3-crop.png'/>
                </Grid>
                <Grid item sm={3}>
                    <FeatureCard
                        title="Keep Others Updated"
                        text="Enable better care coordination with families' caregiving needs through sharing."
                        color="lightgray"
                        image='/img/phone4-crop.png'/>
                </Grid>
            </Grid>
        </div>
    </div>
    )
)

export const FeatureCard = withStyles(styles) (
    ({classes, color, image, title, text}) => (

        <Card className={classes.card} style={{boxShadow: "none"}}>
            <CardMedia
                className={classes.media}
                image={image}
                title={title}
                style={{backgroundColor: color}}
            />
            <CardContent className={classes.cardContent}>
                <Typography gutterBottom variant="headline" component="h2" align="center">
                    <strong>{title}</strong>
                </Typography>
                <Typography component="p" align="center">
                    {text}
                </Typography>
            </CardContent>
        </Card>
    )
)

export default Features1


// WEBPACK FOOTER //
// ./src/components/Features1.jsx